import React from 'react'
import { Link } from 'react-router-dom'
import MainFirst1 from '../../images/MainFirst1.png'
import MainFirst2 from '../../images/MainFirst2.png'
import MainFirst3 from '../../images/MainFirst3.png'
import MainFirst4 from '../../images/MainFirst4.png'
import css from './MainFirst.module.css'

const MainFirst = () => {
	return (
		<section className={css.infoSection}>
			<div className={css.infoTitleWrapper}>
				<h2 className={css.infoTitle}>Zakres pomocy</h2>
			</div>
			<ul className={css.infoList}>
				<li className={css.infoItem}>
					<img className={css.infoImg} alt='icon' src={MainFirst1} />
					<h3 className={css.infoSubtitle}>Pomoc psychologiczna</h3>
					<p className={css.infoText}>
						Profesjonalna pomoc psychologiczna jest dedykowana osobам, które
						przeżywają kryzysowe momenty, zmagają się z wyzwaniami osobistymi
						lub trudnościami życiowymi oraz mają trudności z adaptacją do nowych
						sytuacji.
					</p>
					<Link to='/oferta'>
						<button className={css.infoButton}>Zobacz więcej</button>
					</Link>
				</li>
			{/*	<li className={css.infoItem}>
					<img className={css.infoImg} alt='icon' src={MainFirst2} />
					<h3 className={css.infoSubtitle}>Psychoterapia indywidualna</h3>
					<p className={css.infoText}>
						Terapia integracyjna to wszechstronny rodzaj wsparcia
						psychologicznego, skierowany do osób dorosłych, które zmagają się z
						różnymi trudnościami osobistymi, takimi jak problemy emocjonalne,
						kryzysy życiowe czy trudności w relacjach.
					</p>
					<Link to='/oferta'>
						<button className={css.infoButton}>Zobacz więcej</button>
					</Link>
				</li>*/}
				<li className={css.infoItem}>
					<img className={css.infoImg} alt='icon' src={MainFirst3} />
					<h3 className={css.infoSubtitle}>Konsultacje i poradnictwo</h3>
					<p className={css.infoText}>
						Podczas konsultacji terapeuta szczegółowo analizuje naturę problemu
						klienta, uwzględniając jego kontekst życiowy oraz emocje. Celem jest
						znalezienie najlepszych strategii, które pomogą w skutecznym
						rozwiązaniu trudności i poprawią jakość życia klienta.
					</p>
					<Link to='/oferta'>
						<button className={css.infoButton}>Zobacz więcej</button>
					</Link>
				</li>
				<li className={css.infoItem}>
					<img className={css.infoImg} alt='icon' src={MainFirst4} />
					<h3 className={css.infoSubtitle}>Diagnostyka psychologiczna</h3>
					<p className={css.infoText}>
						Diagnoza psychologiczna to proces, podczas którego psycholog,
						korzystając z odpowiednich narzędzi diagnostycznych, stara się
						zrozumieć mechanizmy działania osoby badanej. Celem jest wyjaśnienie
						obecnych trudności oraz przewidywanie sposobów i możliwości ich
						zmiany.
					</p>
					<Link to='/oferta'>
						<button className={css.infoButton}>Zobacz więcej</button>
					</Link>
				</li>
			</ul>
		</section>
	)
}

export default MainFirst
